<div class="colorPickerDisplay t-{{activeTheme.theme}}">
  <mat-toolbar class="colorPickerHeader">
    <p>{{ 'COLOR_PICKER' | translate }}</p>
    <span class="app-toolbar-filler"></span>
    <button mat-button class="buttonIcon" (click)="dialogRef.close()">
      <i class="material-icons">close</i>
    </button>
  </mat-toolbar>

  <mat-grid-list cols="4">
    @for (themeButton of allThemes; track themeButton) {
      <mat-grid-tile [colspan]="2"
        (click)="setColor(themeButton); dialogRef.close()">
        <div class="smallGridDisplay">
          <div class="container {{themeButton}}">
            <div class="smallToolbar smallPrimaryB"></div>
            <div class="smallMessage smallPrimary">{{ 'SUCCESSFULLY_LOGGED_IN' | translate }}</div>
            <div class="smallTime">10:45:03</div>
          </div>
        </div>
      </mat-grid-tile>
    }
  </mat-grid-list>

</div>
